import { ConfirmDialog } from '@/components/ui/confirm-dialog';

interface BasePageVisibilityWarningDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void | Promise<void>;
  onCancel?: () => void;
  stopPointerDownPropagation?: boolean;
}

export type PageVisibilityWarningDialogProps = BasePageVisibilityWarningDialogProps &
  ({ variant: 'move' | 'publish' } | { variant: 'unpublish'; subpageCount: number });

export function PageVisibilityWarningDialog({
  stopPointerDownPropagation,
  ...props
}: PageVisibilityWarningDialogProps) {
  const title =
    props.variant === 'move'
      ? 'Move this page?'
      : props.variant === 'unpublish'
        ? 'Unpublish this page?'
        : 'Publish this page?';

  const description =
    props.variant === 'move' ? (
      <span>This page won't appear in navigation until its parent page is published.</span>
    ) : props.variant === 'unpublish' ? (
      <span>
        This page and its {props.subpageCount} {props.subpageCount === 1 ? 'subpage' : 'subpages'}{' '}
        will be hidden from navigation until it's published again.
      </span>
    ) : (
      <span>This page won't appear in navigation until its parent page is published.</span>
    );

  const confirmLabel =
    props.variant === 'move'
      ? 'Move page'
      : props.variant === 'unpublish'
        ? 'Unpublish'
        : 'Publish anyway';

  return (
    <ConfirmDialog
      open={props.open}
      onOpenChange={props.onOpenChange}
      title={title}
      description={description}
      confirmLabel={confirmLabel}
      cancelLabel="Cancel"
      onConfirm={props.onConfirm}
      onCancel={props.onCancel}
      confirmColorScheme={props.variant === 'unpublish' ? 'destructive' : 'primary'}
      showCloseButton={false}
      stopPointerDownPropagation={stopPointerDownPropagation}
    />
  );
}
